import { createStyles, makeStyles, Typography } from "@material-ui/core";
import {
    RelodeTheme,
    StatusLabel,
    CandidateVerificationStatusLabel,
} from "../../";
import * as domain from "../../domain";
import * as React from "react";

import { Panel, PanelProps } from "./panel";
import classnames from "classnames";
import { JobCandidateStatus } from "../../domain";

const useStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "grid",
            flexGrow: 1,
        },
        threeColumns: {
            gridTemplateColumns: "auto 1fr auto",
        },
        fourColumns: {
            gridTemplateColumns: "auto auto 1fr auto",
        },
        daysInStatus: {
            color: theme.palette.text.secondary,
            justifySelf: "center",
        },
        verificationStatus: {
            marginLeft: theme.spacing(1),
            [theme.breakpoints.down("md")]: {
                marginRight: theme.spacing(1),
            },
        },
    })
);

interface StatusPanelProps extends Omit<PanelProps, "heading"> {
    daysInStatus?: number;
    status: domain.JobCandidateStatus;
    verificationStatus?: domain.CandidateVerificationStatus;
    isCurrent: boolean;
    device?: "desktop" | "mobile";
}

export const statusPanel = (props: StatusPanelProps) => {
    const {
        daysInStatus,
        status,
        isCurrent,
        verificationStatus,
        device,
        ...rest
    } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = useStyles({});

    const days =
        daysInStatus === 1
            ? `${daysInStatus} day in status`
            : `${daysInStatus} days in status`;

    const renderDays = (): string => {
        let days = "";
        if (
            device === "mobile" &&
            status.id === JobCandidateStatus.Qualifying.id &&
            verificationStatus
        ) {
            days =
                daysInStatus === 1
                    ? `${daysInStatus} day`
                    : `${daysInStatus} days`;

            return days;
        }
        days =
            daysInStatus === 1
                ? `${daysInStatus} day in status`
                : `${daysInStatus} days in status`;

        return days;
    };

    const rootClass = classnames(classes.root, {
        [classes.threeColumns]: !verificationStatus,
        [classes.fourColumns]: !!verificationStatus,
    });
    return (
        <Panel
            {...rest}
            heading={
                <div className={rootClass}>
                    <div>
                    <StatusLabel jobCandidateStatus={status}/>
                    </div>                    
                        {verificationStatus && (
                            <div className={classes.verificationStatus}>
                                <CandidateVerificationStatusLabel
                                    className={classes.verificationStatus}
                                    verificationStatus={verificationStatus}
                                />
                            </div>
                        )}
                        {!!isCurrent && (
                            <Typography
                                variant="body1"
                                className={classes.daysInStatus}
                            >
                                {renderDays()}
                            </Typography>
                        )}
                </div>
            }
        />
    );
};
